if (!customElements.get('site-counter')) {
    customElements.define(
        'site-counter',
        class SiteCounter extends HTMLElement {
            constructor() {
                super();
                this.current = 0;
                this.isVisible = false;

                this.targetElement = this.querySelector('[data-count-target]');

                this.intersectionObserver = new IntersectionObserver(entries => {
                    entries.forEach(entry => {
                        if (entry.isIntersecting) {
                            this.isVisible = true;
                            this.startInterval();
                        } else {
                            this.isVisible = false;
                            this.stopInterval();
                        }
                    });
                });
                this.intersectionObserver.observe(this);
            }

            startInterval() {
                if (this.intervalId) return;


                setTimeout(() => {
                    this.intervalId = setInterval(() => {

                        if (this.current < this.dataset.count) {
                            this.current += this.dataset.count / 10;
                            this.targetElement.innerHTML = this.current.toLocaleString();
                        } else {
                            this.targetElement.innerHTML = Number(this.dataset.count).toLocaleString();
                            this.stopInterval();
                        }
                    }, 100);
                }, Number(this.dataset.delay));

            }

            stopInterval() {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }

            disconnectedCallback() {
                this.intersectionObserver.unobserve(this);
                this.stopInterval();
            }
        }
    );
}
